import { render, staticRenderFns } from "./GroupHeader.vue?vue&type=template&id=c97a22ca&scoped=true&"
import script from "./GroupHeader.vue?vue&type=script&lang=js&"
export * from "./GroupHeader.vue?vue&type=script&lang=js&"
import style0 from "./GroupHeader.vue?vue&type=style&index=0&id=c97a22ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97a22ca",
  null
  
)

export default component.exports